import type { RouteLocation, RouteLocationRaw } from 'vue-router'

export interface IMegaMenuItem {
	title?: string
	translation_key_title?: string
	link?: string | RouteLocation | RouteLocationRaw
	subText?: string
	translation_key_subText?: string
	icon?: string
	menu?: boolean
	filters?: string[]
	items?: IMegaMenuItem[]
	location?: string // for gtm
	rental_length?: string // for gtm
	category?: string // for gtm
}

export const nav = [
	{ translation_key_label: 'cars', to: 'cars', type: 'link-dropdown' },
	{
		translation_key_label: 'offer',
		to: '#',
		type: 'dropdown',
	},
	{ translation_key_label: 'locations', to: 'locations', type: 'link' },
	{ translation_key_label: 'frequent_questions', to: 'faq', type: 'link' },
	{ translation_key_label: 'contact', to: 'contact', type: 'link' },
	{ translation_key_label: 'app', to: 'https://aplikacja.carfree.pl/', type: 'link', newTab: true },
	{ translation_key_label: 'news', to: 'blog', type: 'link' },
]

// The mega menu's structure/titles/icons/links - including the dynamic bus/delivery-van/city/airport
// sublinks - now come entirely from the CMS "mega-menu" content section (admin panel: /panel/mega-menu)
// plus each CMSLocation's own flags (showInMenu, isActivePL/EN, passengerBus, deliveryBus, otherLocation,
// icon) - see src/components/Global/MegaMenu/megaMenuContentMapper.ts and useMegaMenu.ts.
// No link data is hardcoded here anymore.
